import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const OPTIONS = [
  { id: "weekly", label: "Weekly", hint: "Sunday 6pm UK" },
  { id: "daily", label: "Daily", hint: "Every morning" },
  { id: "off", label: "Off", hint: "No summary emails" },
];

export function SummaryPrefs() {
  const [freq, setFreq] = useState<string | null>(null);
  useEffect(() => { api.get("/me/preferences").then((r) => setFreq((f) => f ?? r.data.summary_frequency)).catch(() => setFreq((f) => f ?? "weekly")); }, []);
  const save = async (id: string) => {
    const prev = freq; setFreq(id);
    try { await api.put("/me/preferences", { summary_frequency: id }); toast.success(id === "off" ? "Summary emails turned off" : `Care summary set to ${id}`); }
    catch { setFreq(prev); toast.error("Could not save preference"); }
  };
  return (
    <div className="mx-auto mb-4 flex max-w-2xl flex-wrap items-center justify-between gap-3 rounded-2xl border border-brand-line bg-white px-4 py-3" data-testid="summary-prefs">
      <div className="flex items-center gap-2 text-sm text-brand-navy"><Mail className="h-4 w-4 text-brand-emerald" /><span className="font-semibold">Care summary email</span></div>
      <div className="flex gap-1 rounded-full bg-slate-100 p-1" role="radiogroup">
        {OPTIONS.map((o) => (
          <button key={o.id} role="radio" aria-checked={freq === o.id} title={o.hint} disabled={freq === null} onClick={() => save(o.id)}
            className={`rounded-full px-3 py-1 text-xs font-semibold transition ${freq === o.id ? "bg-brand-blue text-white" : "text-brand-slate hover:text-brand-navy"}`} data-testid={`summary-pref-${o.id}`}>{o.label}</button>
        ))}
      </div>
    </div>
  );
}
